const SIZES = {
	sm: "h-5 w-5",
	md: "h-6 w-6",
}

export function Spinner({ size = "md" }: { size?: "sm" | "md" }) {
	return (
		<div
			className={`${SIZES[size]} animate-spin rounded-full border-2 border-neon/30 border-t-neon`}
		/>
	)
}
